import React from 'react';
import { SlotWithReservation } from '../types';

interface SlotStatusBadgeProps {
  slot: SlotWithReservation;
}

interface PaymentBadgeProps {
  paymentStatus: string;
}

export function SlotStatusBadge({ slot }: SlotStatusBadgeProps) {
  if (!slot.is_reserved) {
    return <span className="px-2 py-1 text-xs font-medium bg-green-100 text-green-800 rounded-full">Available</span>;
  }

  const status = slot.reservation?.status;
  if (status === 'confirmed') {
    return <span className="px-2 py-1 text-xs font-medium bg-moonbone text-ink rounded-full">Reserved</span>;
  } else if (status === 'pending') {
    return <span className="px-2 py-1 text-xs font-medium bg-yellow-100 text-yellow-800 rounded-full">Pending</span>;
  }

  return <span className="px-2 py-1 text-xs font-medium bg-gray-100 text-gray-800 rounded-full">Unknown</span>;
}

export function PaymentBadge({ paymentStatus }: PaymentBadgeProps) {
  if (paymentStatus === 'paid') {
    return <span className="px-2 py-1 text-xs font-medium bg-green-100 text-green-800 rounded-full">Paid</span>;
  } else if (paymentStatus === 'pending') {
    return <span className="px-2 py-1 text-xs font-medium bg-yellow-100 text-yellow-800 rounded-full">Pending Payment</span>;
  } else if (paymentStatus === 'refunded') {
    return <span className="px-2 py-1 text-xs font-medium bg-gray-100 text-gray-800 rounded-full">Refunded</span>;
  }
  return null;
}
